import React from 'react'
import { globalState } from '@codeleap/store'
import { useEffect } from 'react'
import { SuccessOverlay } from '../../SuccessOverlay'
import { useIsMobile } from '@/utils'
import { LocalStorageKeys } from '@/app'

const tutorialDone = globalState(false, { persistKey: LocalStorageKeys.FEED_HELP_OVERLAY })

export const FeedHelpOverlay = () => {
  const done = tutorialDone.use()
  const isMobile = useIsMobile()

  useEffect(() => {
    if (done) return

    const timeoutId = setTimeout(() => {
      FeedHelpOverlay.hide()
    }, 5000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [done])

  return (
    <SuccessOverlay
      visible={!done}
      icon='swipe-down'
      description={
        <>
          Swipe up
          <br />
          for more
        </>
      }
      textStyle={
        isMobile
          ? ['h1', 'extraBold', 'color:neutral2', 'textCenter']
          : ['h0', 'extraBold', 'color:neutral2', 'textCenter']
      }
    />
  )
}

FeedHelpOverlay.hide = () => tutorialDone.set(true as never)
